import { useQuery } from "react-query";
import { getHost } from '../../util/host';

const fetchNewsDigest = async () => {
  const host = getHost(true, false);
  const res = await fetch(`${host}/api/v1/news/get_digest`);
  if (!res.ok) throw new Error('Network response was not ok');
  return res.json();
};

const NewsDigest = () => {
  const { data, isLoading, error } = useQuery(['newsDigest'], fetchNewsDigest);

  if (isLoading) {
    return <div>Loading news digest...</div>;
  }

  if (error) {
    return <div>Error loading news digest: {error.message}</div>;
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #e0e7ef 0%, #f8fafc 100%)',
      padding: '40px 0',
      boxSizing: 'border-box',
    }}>
      <div style={{
        maxWidth: 768,
        margin: '0 auto',
        padding: 32,
        background: 'rgba(255,255,255,0.92)',
        borderRadius: 24,
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
        border: '1px solid #c7d6f9',
      }}>
        <h4>News Digest</h4>
        <div dangerouslySetInnerHTML={{ __html: data?.content }}>
        </div>
      </div>
    </div>
  );
};

export default NewsDigest;
